import type { RouteConfig } from "../models/types";
import TaskListIndex from "@/pages/task-list";

export const taskListRoutes: RouteConfig[] = [
	{
		path: "/task-list",
		element: <TaskListIndex />,
	},
	{
		path: "/task-list/area",
		element: <TaskListIndex />,
	},
	{
		path: "/task-list/area/:AssetIdParam",
		element: <TaskListIndex />,
	},
	{
		path: "/task-list/downday",
		element: <TaskListIndex />,
	},
	{
		path: "/task-list/downday/:AssetIdParam",
		element: <TaskListIndex />,
	},
	{
		path: "/task-list/:AssetIdParam",
		element: <TaskListIndex />,
	},
];
